module.exports = __webpack_public_path__ + "media/customizations/pomonalife/back-a09d09b64b6d7584fb624c0e12cc955e.jpg";